import React from 'react'
import { Modal,Button} from 'react-bootstrap';
import PropTypes from 'prop-types'

const NotifyError = props => {
    const {isHide, handleCloseErrorModal, title, message, Errors} = props;
    
    let isValidationError = Errors ? true : false
  return (
    <div>
         <Modal show={!isHide} onHide={handleCloseErrorModal}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
       { isValidationError ? <Modal.Body>

        {Errors.map((item) => (
        <div>{item.Reason}</div>
      ))}

        </Modal.Body>
        : <Modal.Body>{message}</Modal.Body>
        
        }
    
        <Modal.Footer>
          <Button variant="success" onClick={handleCloseErrorModal}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

Notification.propTypes = {}

export default NotifyError